var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnShower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 15.839 21.884",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fffffe",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.828 3.491V0H6.537v3.508C-.4 4.294 0 11.437 0 11.437h15.753C15.8 5 10.975 3.737 8.828 3.491M.032 13.58h15.807v-1.654H.032zM3.324 14.324a1.125 1.125 0 101.123 1.125 1.124 1.124 0 00-1.123-1.125M9.772 14.324a1.124 1.124 0 101.128 1.125 1.124 1.124 0 00-1.125-1.125M3.324 17.237a1.013 1.013 0 101.011 1.014 1.014 1.014 0 00-1.011-1.014M9.772 17.237a1.013 1.013 0 101.012 1.014 1.014 1.014 0 00-1.012-1.014M3.324 20.176a.854.854 0 10.854.854.856.856 0 00-.854-.854M9.772 20.176a.854.854 0 10.855.854.855.855 0 00-.855-.854M6.524 14.324a1.124 1.124 0 101.125 1.125 1.125 1.125 0 00-1.125-1.125M12.974 14.324a1.125 1.125 0 101.126 1.125 1.125 1.125 0 00-1.123-1.125M6.524 17.237a1.013 1.013 0 101.012 1.014 1.015 1.015 0 00-1.012-1.014M12.974 17.237a1.013 1.013 0 101.01 1.014 1.016 1.016 0 00-1.01-1.014M6.525 20.176a.854.854 0 10.854.854.857.857 0 00-.854-.854M12.974 20.176a.854.854 0 10.853.854.854.854 0 00-.853-.854"
  }))));
}

export default SvgIcnShower;